const getters = {
    c_id: state => state.user.c_id,
    c_name: state => state.user.c_name,
    c_avatar: state => state.user.c_avatar,
    c_role_id: state => state.user.c_role_id,
    c_role_name: state => state.user.c_role_name,
    c_role_level: state => state.user.c_role_level,
    c_project_id: state => state.user.c_project_id,
    c_menu: state => state.user.c_menu,
    c_bread: state => state.user.c_bread,
    c_index: state => state.user.c_index,
    activeMenu: state => state.user.activeMenu,
    host: state => 'http://122.152.198.146:6268/',
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js